module.exports = __webpack_public_path__ + "img/pro_five_13.3dfe6a63.jpg";